// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"addEditLabel_buttonsContainer__2qzTM","confirmButton":"addEditLabel_confirmButton__NJJuG","cancelButton":"addEditLabel_cancelButton__2qLLh"};